//
// Manages floating ads.
function AdsNinjaFloatingStrategy(logger, options = {}, callbacks = {}){

    this.__logger    = logger;
    this.__options   = options;
    this.__callbacks = callbacks;
}

//
// Handle request to float.
AdsNinjaFloatingStrategy.prototype.handleRequestToFloat = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){

    var foundInfo = state[requestDetails.originalElementId];

    if(foundInfo){

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        this.__logger.warn('Float request rejected. Ad is already floating.', returnResult);

        return returnResult;
    }

    requestDetails.floatCallback(requestDetails.context);

    var updatedStateResult    = this._updateStateAfterRequestToFloat(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
    requestDetails            = updatedStateResult.requestDetails;
    adTypeMapping             = updatedStateResult.adTypeMapping;
    floatAdTypeRequestQueue   = updatedStateResult.floatAdTypeRequestQueue;
    positionMapping           = updatedStateResult.positionMapping;
    floatPositionRequestQueue = updatedStateResult.floatPositionRequestQueue;
    state                     = updatedStateResult.state;
    disabledElements          = updatedStateResult.disabledElements;

    return this.__resultHelper(true, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
};

//
// Handle request to defloat.
AdsNinjaFloatingStrategy.prototype.handleRequestToDefloat = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements, floatNextAvailableElement = true){

    var foundInfo = state[requestDetails.originalElementId];

    if(!foundInfo){

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        this.__logger.warn('Defloat request rejected. Ad is not floating.', returnResult);

        return returnResult;
    }

    requestDetails.defloatCallback(requestDetails.context);

    var updatedStateResult    = this._updateStateAfterRequestToDefloat(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
    requestDetails            = updatedStateResult.requestDetails;
    adTypeMapping             = updatedStateResult.adTypeMapping;
    floatAdTypeRequestQueue   = updatedStateResult.floatAdTypeRequestQueue;
    positionMapping           = updatedStateResult.positionMapping;
    floatPositionRequestQueue = updatedStateResult.floatPositionRequestQueue;
    state                     = updatedStateResult.state;
    disabledElements          = updatedStateResult.disabledElements;

    return this.__resultHelper(true, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
};

//
// Handle enable element.
AdsNinjaFloatingStrategy.prototype.handleEnableElement = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){

    var index = disabledElements.indexOf(requestDetails.originalElementId);

    if(-1 !== index){

        disabledElements.splice(index, 1);
    }

    // Temporary.
    var refreshAdZone = window.adsNinjaHeaderBiddingManager.refreshingAdZones[requestDetails.originalElementId];

    if(refreshAdZone){

        refreshAdZone.setFloatingAllowed();
    }

    return {
        requestDetails: requestDetails,
        adTypeMapping: adTypeMapping,
        floatAdTypeRequestQueue: floatAdTypeRequestQueue,
        positionMapping: positionMapping,
        floatPositionRequestQueue: floatPositionRequestQueue,
        state: state,
        disabledElements: disabledElements,
    };
};

//
// Handle disable element.
AdsNinjaFloatingStrategy.prototype.handleDisableElement = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){

    if(-1 === disabledElements.indexOf(requestDetails.originalElementId)){

        disabledElements.push(requestDetails.originalElementId);
    }

    // Temporary.
    var refreshAdZone = window.adsNinjaHeaderBiddingManager.refreshingAdZones[requestDetails.originalElementId];

    if(refreshAdZone){

        refreshAdZone.setNoFloatingAllowed();
    }

    return {
        requestDetails: requestDetails,
        adTypeMapping: adTypeMapping,
        floatAdTypeRequestQueue: floatAdTypeRequestQueue,
        positionMapping: positionMapping,
        floatPositionRequestQueue: floatPositionRequestQueue,
        state: state,
        disabledElements: disabledElements,
    };
};

//
// Update state.
AdsNinjaFloatingStrategy.prototype._updateStateAfterRequestToFloat = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){

    state[requestDetails.originalElementId] = requestDetails;
    
    adTypeMapping[requestDetails.adType].push(requestDetails.originalElementId);
    positionMapping[requestDetails.position].push(requestDetails.originalElementId);

    return {
        requestDetails: requestDetails,
        adTypeMapping: adTypeMapping,
        floatAdTypeRequestQueue: floatAdTypeRequestQueue,
        positionMapping: positionMapping,
        floatPositionRequestQueue: floatPositionRequestQueue,
        state: state,
        disabledElements: disabledElements,
    };
};

//
// Update state.
AdsNinjaFloatingStrategy.prototype._updateStateAfterRequestToDefloat = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){

    delete state[requestDetails.originalElementId];

    var indexOfAdTypeMapping = adTypeMapping[requestDetails.adType].indexOf(requestDetails.originalElementId);

    if(indexOfAdTypeMapping !== -1){

        adTypeMapping[requestDetails.adType].splice(indexOfAdTypeMapping, 1);
    }

    floatAdTypeRequestQueue[requestDetails.adType] = floatAdTypeRequestQueue[requestDetails.adType].filter(function(element){

        return requestDetails.originalElementId !== element.originalElementId;
    });

    var indexOfPositionMapping = positionMapping[requestDetails.position].indexOf(requestDetails.originalElementId);

    if(indexOfPositionMapping !== -1){

        positionMapping[requestDetails.position].splice(indexOfPositionMapping, 1);
    }

    floatPositionRequestQueue[requestDetails.position] = floatPositionRequestQueue[requestDetails.position].filter(function(element){
        
        return requestDetails.originalElementId !== element.originalElementId;
    });

    return {
        requestDetails: requestDetails,
        adTypeMapping: adTypeMapping,
        floatAdTypeRequestQueue: floatAdTypeRequestQueue,
        positionMapping: positionMapping,
        floatPositionRequestQueue: floatPositionRequestQueue,
        state: state,
        disabledElements: disabledElements,
    };
};

//
// Float next available element.
AdsNinjaFloatingStrategy.prototype._floatNextAvailableElement = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){

    return this.__resultHelper(true, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
};

//
// Result helper.
AdsNinjaFloatingStrategy.prototype.__resultHelper = function(requestApproved, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){
    
    return {
        requestApproved: requestApproved,
        requestDetails: requestDetails,
        adTypeMapping: adTypeMapping,
        floatAdTypeRequestQueue: floatAdTypeRequestQueue,
        positionMapping: positionMapping,
        floatPositionRequestQueue: floatPositionRequestQueue,
        state: state,
        disabledElements: disabledElements,
    };
};

window.AdsNinjaFloatingStrategy = AdsNinjaFloatingStrategy;